export function imagePreview (obj, files) {
    // Because of browser security we have to use the FileReader API
    // to create a preview of the image
    let file = files[0];
    let reader = new FileReader();

    if (file) {
      obj.file = file;

      reader.onloadend = (e) => {
        obj.preview = e.target.result;
      };

      // read the image file as a base64 encoded string
      reader.readAsDataURL(file);
    }
}

export function cleanSource (source) {
  // using native JSON functions removes reactivity
  // so we can clone an object without mutating the original source
  return JSON.parse(JSON.stringify(source));
}

export function addNoScroll (url) {
  return document.body.classList.add('has-no-scroll');
}

export function removeNoScroll (url) {
  return document.body.classList.remove('has-no-scroll');
}

export function capitalize (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function pluralize (count, noun, suffix = 's') {
  return `${noun}${count !== 1 ? suffix : ''}`;
}

// Generates a random integer between min & max
export function randomNum (min, max, decimals = 2) {
  let random = Math.random() * (max - min) + min;

  return parseFloat(random.toFixed(decimals));
}

// Generates a random integer between min & max
export function randomInt (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Converts booleans to integers
export function boolToInt (bool) {
  return bool ? 1 : 0;
}

// Converts local date/time to UTC date/time  
export function convertDateToUTC (date, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(date).utc().format(format);
}

// Converts UTC date/time to local date/time  
export function convertUTCToDate (date, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment.utc(date).local().format(format);
}

export const select = (s, scope = document) => { return scope.querySelector(s) };
export const selectAll = (s, scope = document) => { return scope.querySelectorAll(s) };

// Uses GSAP ScrollToPlugin via CDN
// GSAP is registered globally via CDN
export function scrollToSelector (selector) {
  // Animated scroll to position
  TweenLite.to(window, 0.8, { scrollTo: { y: document.querySelector(selector), autoKill: false }, ease: Power2.easeOut });
}

// Taken from Underscore.js
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce (func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};


// WEBPACK FOOTER //
// ./resources/assets/js/shared/utilities.js